import { useMutation, useQueryClient } from '@tanstack/react-query'
import { AxiosError } from 'axios'

import { api } from '@/utils/api'

type Args = {
  linkId: string
  emails: string[]
}

export const useShareLink = () => {
  const queryClient = useQueryClient()

  return useMutation<
    { success: boolean },
    AxiosError<{ message: string }>,
    Args
  >({
    mutationFn: async ({ linkId, emails }) => {
      const { data } = await api.post(`/links/${linkId}/share`, {
        emails,
      })
      return data.data
    },
    onSuccess: (_, args) => {
      queryClient.invalidateQueries({
        queryKey: ['shared-with', args.linkId],
      })
    },
  })
}
